import {forwardRef} from "react";

import {RootDesc} from "@ui/descriptions/RootDesc";
import {motion} from "framer-motion";

import styles from "./styles.module.scss";

export const RootButton = forwardRef((props, ref) => {
  const {txt, type, onClick, disabled, tabIndex, className} = props;

  return type === "submit" ? (
    <button
      ref={ref}
      className={`${styles.rootButton} ${className}`}
      type={type || "button"}
      disabled={disabled}
      tabIndex={tabIndex ? tabIndex : undefined}
      // onKeyDown={tabIndex ? handleKeyDown : undefined}
      role={"submit"}
    >
      <RootDesc>{txt}</RootDesc>
    </button>
  ) : (
    <button
      ref={ref}
      className={`${styles.rootButton} ${className}`}
      type={type || "button"}
      onClick={onClick}
      disabled={disabled}
    >
      <RootDesc>{txt}</RootDesc>
    </button>
  );
});

export const MRootButton = motion(RootButton);
